var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 13.993,
    viewBox: "0 0 20 13.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M1428.336,89.328l5.187-3-5.187-3ZM1439.88,81.5a9.841,9.841,0,0,1,.285,1.9c.075.8.1,1.489.1,2.089l.06.84a19.5,19.5,0,0,1-.45,4.828,2.32,2.32,0,0,1-1.724,1.729,14.107,14.107,0,0,1-2.654.28c-1.289.07-2.488.1-3.583.1l-1.589.06a40.98,40.98,0,0,1-7.826-.44,2.321,2.321,0,0,1-1.724-1.729,9.879,9.879,0,0,1-.285-1.9c-.074-.8-.1-1.489-.1-2.089l-.06-.84a19.5,19.5,0,0,1,.45-4.828,2.321,2.321,0,0,1,1.724-1.729,14.1,14.1,0,0,1,2.654-.28c1.289-.07,2.489-.1,3.583-.1l1.589-.06a40.982,40.982,0,0,1,7.826.44A2.32,2.32,0,0,1,1439.88,81.5Z",
    transform: "translate(-1420.33 -79.333)",
    fill: "#b50e07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.9c9bf97611988edbbf6d42edd4d0451e.svg";
export { ForwardRef as ReactComponent };